function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}"));
var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M223,273.19a1.34,1.34,0,0,0-1.39-1.3h-.72a5.87,5.87,0,0,1-9.78,0h-.71a1.35,1.35,0,0,0-1.4,1.3l-1.39,9.5A1.35,1.35,0,0,0,209,284h14a1.35,1.35,0,0,0,1.39-1.31Z",
  transform: "translate(-207.16 -263.55)"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M216,273.37a4.69,4.69,0,1,0-4.68-4.69A4.69,4.69,0,0,0,216,273.37Z",
  transform: "translate(-207.16 -263.55)"
});
function SvgContactIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "22px",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.68 20.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _ref2, title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Contacts") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIcon);
export default __webpack_public_path__ + "static/media/ContactIcon.807328d4.svg";
export { ForwardRef as ReactComponent };